import {useGetAllUsers} from 'modules/users'
import {Box, Button, Form, FormItem, Select, UserItem} from 'common/components'
import {FIELD_RULES} from 'common/constants'
import {VC_TEAM_ID} from '../../rbac/config'
import {useAcceptRequestStatus, useAssignManager} from '..'
import { IManagerProps } from '../../project/components/ProjectCard'
interface ManagerAssignFormProps {
  request?: any
  projectUuid: string
  manager?: any
  almList?:IManagerProps[]
  onClose: () => void
}

export default function ManagerAssignForm({
  request,
  projectUuid,
  manager,
  almList,
  onClose,
}: ManagerAssignFormProps) {
  const {data: managers, isLoading: isManagersLoading} = useGetAllUsers(
    'managers',
    'associated-manager,manager',
    VC_TEAM_ID
  )
  const {
    mutate: acceptRequestStatus,
    isMutating: isAcceptRequestStatusMutating,
  } = useAcceptRequestStatus(request?.uuid, onClose)
  const {mutate: assignManager, isMutating: isAssignManagerMutating} =
    useAssignManager(
      projectUuid,
      request?.status === 'loans-coordinator-check'
        ? acceptRequestStatus
        : onClose
    )

  const handleFinish = (values: any) => assignManager(values)

  const managerOptions = managers?.filter(
    (x:any) => x.role === 'manager'
  ).map((manager) => ({
    value: manager.uuid,
    label: <UserItem user={manager} />,
  })) || []
  const amanagerOptions = managers?.filter(
    (x:any) => x.role === 'associated-manager'
  ).map((manager) => ({
    value: manager.uuid,
    label: <UserItem user={manager} />,
  })) || []

  const initialValues = ( Boolean(manager) && !!almList?.length ) ? {
    manager: manager.uuid,
    alms: almList.map((x:IManagerProps) => x.uuid),
  } : Boolean(manager) ? {
    manager: manager.uuid,
  } : Boolean(almList?.[0]) ? {
    alms: almList.map((x:IManagerProps) => x.uuid),
  } :
  undefined

  return (
    <Form initialValues={initialValues} onFinish={handleFinish}>
      <FormItem name="manager" label="Assign lending manager" rules={FIELD_RULES}>
        <Select
          autoFocus
          loading={isManagersLoading}
          options={managerOptions}
        />
      </FormItem>
      <FormItem name="alms" label="Assign assistant lending manager" 
        // rules={FIELD_RULES}
      >
        <Select
          mode="multiple"
          autoFocus
          loading={isManagersLoading}
          options={amanagerOptions}
        />
      </FormItem>

      <Box align="right">
        <Button
          className='Button_type_form Button_type_form_cancel'
          loading={isAssignManagerMutating || isAcceptRequestStatusMutating}
          onClick={onClose}
        >
          Cancel
        </Button>
        &nbsp;
        <Button className='Button_type_form Button_type_form_submit'
          htmlType="submit"
          loading={isAssignManagerMutating || isAcceptRequestStatusMutating}
        >
          Confirm
        </Button>
      </Box>
    </Form>
  )
}
